









import Login from '@/components/Login.vue';
export default {
  name: 'logInOut',
  components: {
    Login,
  },
};
